<template>
  <div class="ui secondary pointing fluid menu">
    <router-link v-for="(tab, index) in tabList"
                 :to="{ name: tab.routeName }"
                 :key="index"
                 :class="{ active: ( $route.path === tab.routePath)}" class="item">
      {{ tab.text }}
    </router-link>

    <div class="right menu">

      <router-link :to="{ name: 'PagePatientCreate' }"
                   class="ui small item">
        <div class="ui primary button">
          <i class="plus icon"></i>New Patient
        </div>
      </router-link>
      <a class="ui item" @click="clearAllSessionData({infoMessage: 'logout'})">
        Logout
      </a>
    </div>
  </div>
</template>

<script>
  //TODO: set a state variable for the computed props of this
	export default {
		data() {
			return {
			  activeTab: null,
        tabList: [
          {
            routePath: '/patient',
            routeName: 'TabPatient',
            text: 'Patient Monitoring'
          },
          {
            routePath: '/action',
            routeName: 'ActionPlan',
            text: 'My Actions'
          },
          {
            routePath: '/lesson',
            routeName: 'LessonPlan',
            text: 'My Lessons'
          },
          // {
          //   routePath: '/assessment',
          //   routeName: 'Assessment',
          //   text: '3E Assessments'
          // },
          {
            routePath: '/help',
            routeName: 'GetStarted',
            text: 'FAQs'
          }
        ],
      }
		},
		computed: {

    },
		methods: {},
		mounted() {

		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/NavBackOfficeTop.vue